module.exports = __webpack_public_path__ + "static/media/luna.21bfed28.png";